import * as moment from 'moment-timezone'

export default {
  encodeToBase64: function (str) {
    return window.btoa(str)
  },
  decodeFromBase64: function (base64Str) {
    return window.atob(base64Str)
  },
  encodeToBase64Url: function (str) {
    let base64Str = this.encodeToBase64(str)
    var base64Url = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
    return base64Url
  },
  decodeFromBase64Url: function (base64Url) {
    if (base64Url.length % 4 === 2) base64Url = base64Url + '=='
    if (base64Url.length % 4 === 3) base64Url = base64Url + '='
    let base64Str = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let str = this.decodeFromBase64(base64Str)
    return str
  },
  capitalizeFirstLetter: function (string) {
    string = string.toLowerCase()
    return string.charAt(0).toUpperCase() + string.slice(1)
  },
  getUtcOffset: function (timezone) {
    return moment().tz(timezone).utcOffset()
  },
  getTodayBeginTimestamp: function (timezoneOffset) {
    let now = new Date()
    let timestamp = now.getTime()
    if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
    let localNow = new Date(timestamp)
    timestamp = Math.floor((new Date((new Date(localNow.setHours(0))).setMinutes(0))).setSeconds(0) / 1000) * 1000
    if (timezoneOffset !== undefined) timestamp -= (now.getTimezoneOffset() * 60 * 1000 + timezoneOffset * 60 * 1000)
    return timestamp
  },
  getNowTimestamp: function (timezoneOffset) {
    let now = new Date()
    let timestamp = now.getTime()
    if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
    return timestamp
  },
  getLocalTimestamp: function (timestamp, timezoneOffset) {
    let now = new Date()
    if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
    return timestamp
  },
  hasAllKeys: function (obj, keys) {
    let result = false
    if (obj instanceof Object && keys instanceof Array) {
      let undefinedKeys = []
      keys.map(key => {
        if (obj[key] === undefined) undefinedKeys.push(key)
      })
      if (undefinedKeys.length === 0) result = true
      else {
        console.log('utils.hasAllKeys failed')
        console.log(undefinedKeys)
      }
    } else {
      console.log('utils.hasAllKeys failed')
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/services/functions.js